import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import images from "../../assets/images";
import { useTranslate } from "../../context/TranslationContext";
import "./style.css";

const Error = () => {
  const { t } = useTranslate("error");
  const { user } = useSelector((state) => state.authSlice);

  useEffect(() => {
    document.title = "Traineego | Error 404";
  }, []);

  return (
    <div className="errorContent">
      <img src={images.error.error} alt="Error" />
      <h2>404</h2>
      <h3>{t("pageNotFound")}</h3>
      <Link to={"/"} className="text-white fw-bold">
        {t("goHome")}
      </Link>
    </div>
  );
};

export default Error;
